import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';
@Component({
  selector: 'app-issue-jcash',
  templateUrl: './issue-jcash.component.html',
  styleUrls: ['./issue-jcash.component.css']
})
export class IssueJcashComponent implements OnInit {
  changescidForm: UntypedFormGroup;
  formErrors = {
    'amt': '',
    'expDate': '',
    'name': '',
    'spendLimit':''
  };
  ValidationMessages = {

    'expDate': {
      'required': 'Expiry Date is Required',
    },
    'name': {
      'required': 'Name is Required',
    },
    'amt': {
      'required': 'Amount is Required',
      'pattern': 'Only numbers are allowed'
    },
    'spendLimit': {
      'required': 'Spend Limit is Required',
    },
    
  };
  consumerId: any;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  expDate: any;
  amt: any;
  name:any;
  spendLimit:any;
  activeQs: any = [];
  qids: any = [];
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customerService: CustomerService) {
    this.consumerId = this.data;
  }
  ngOnInit() {
    this.activeQs = this.data.accId;
    // console.log(this.activeQs)
  }
  issueJcash() {
     const qids = this.activeQs.map(q => q.id);
    //  console.log(qids)
    this.api_error = '';
    this.api_success = '';
    const post_data = {
      'expiryDate': this.expDate,
      'amt': this.amt,
      'name': this.name,
      'spendLimit': this.spendLimit,
      'consumerIds': qids,
    }
    // console.log(post_data)
    this.customerService.issueJaldeeCash(post_data)
      .subscribe(res => {
        this.api_success = 'Jaldee Cash Issued successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      },
        (error) => {
          this.disableConfirmbtn = false;
          this.api_error = error.error;
        }
      );
  }
}
